// i18n area 'cluster' — locale bg-BG (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.bg-BG.meta.json.
import type { enUS } from './cluster'

export const bgBG: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Гаранционни достъпи',
      subtitle: 'Сервизната врата на възела: достъпът само за четене с временна парола и аварийният акаунт с паролата от сейфа',
      readOnlyTitle: 'Достъп само за четене (trantor)',
      stateNone: 'затворен',
      stateGranted: 'отворен',
      stateGrantedPending: 'предоставен — прилага се на възела',
      grantedBy: 'Предоставен от',
      grantedAt: 'Предоставен на',
      expiresAt: 'Изтича на',
      reason: 'Причина',
      endedAt: 'Затворен',
      endedReason: {
        revoked: 'отменен',
        expired: 'изтекъл (TTL)',
        reboot: 'рестартиране на възела',
        failed: 'неприложен (задачата се провали)'
      },
      grant: 'Предоставяне на достъп само за четене…',
      grantTitle: 'Предоставяне на достъп само за четене',
      grantSubmit: 'Предостави',
      grantError: 'Предоставянето беше отказано',
      grantConfirm: 'TVirt генерира временна парола за системния потребител «trantor» (само четене: journal и диагностика, без sudo) и я задава на възела чрез задача. Паролата се показва САМО веднъж, при потвърждението; спира да важи при изтичане, при отмяна или при следващото рестартиране на възела.',
      reasonLabel: 'Причина',
      reasonHint: 'Защо отваряте вратата: остава в предоставянето, в одита и в дневника',
      ttlLabel: 'Продължителност',
      ttlHours: '{n} ч',
      revoke: 'Отмяна на достъпа само за четене…',
      revokeTitle: 'Отмяна на достъпа само за четене',
      revokeSubmit: 'Отмени',
      revokeError: 'Отмяната беше отказана',
      revokeConfirm: 'Предоставянето приключва веднага и задача отново заключва потребителя «trantor» на възела: временната парола спира да важи.',
      passwordTitle: 'Парола само за четене',
      passwordOnce: 'Тази парола се показва САМО веднъж: копирайте я сега. Не се съхранява никъде и не може да бъде прочетена отново — ако я загубите, предоставете отново.',
      passwordUser: 'Потребител',
      passwordLabel: 'Парола',
      passwordHint: 'Валидна до {until} или до следващото рестартиране на възела; използваема, когато задачата за предоставяне е завършена. Достъп: ssh trantor@<адрес на възела>.',
      emergencyTitle: 'Последен авариен достъп (trantor-emergency)',
      lastLogin: '{time} чрез {via} от {from}',
      lastLoginNone: 'не е наблюдаван',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'конзола',
        sudo: 'sudo',
        unknown: 'неизвестно'
      },
      emergencyHint: 'Аварийният акаунт «trantor-emergency» (пълен sudo) е винаги активен с паролата, генерирана при инсталацията на възела и пазена в сейфа: TVirt не я знае, не я ротира и не я възстановява. Всяко влизане се докладва тук и в дневника на събитията.'
    },
    nodeFirewall: {
      tab: 'Защитна стена',
      title: 'Защитна стена на възлите',
      subtitle: 'Позицията на nftables ruleset-а, който всеки възел прилага върху себе си — единствената защитна стена на един възел (firewalld е изключен)',
      modeLabel: 'Позиция',
      mode: {
        disabled: 'Изключена — никакъв ruleset на възлите',
        permissive: 'Разрешителна — брои и записва, не отхвърля нищо',
        enforced: 'Наложена — влиза само производният регистър'
      },
      hint: {
        disabled: 'Както е днес: възлите не носят никакъв ruleset. Преминете към разрешителна, за да ПРОЧЕТЕТЕ какво би било отхвърлено, преди да бъде отхвърлено.',
        permissive: 'Всеки възел прилага собствения си производен ruleset с policy accept: това, което наложената позиция би отхвърлила, се брои и записва (префикс в journal «tvirt-node would-drop:»). Нищо не се блокира.',
        enforced: 'Всеки възел прилага собствения си производен ruleset с policy drop: ssh и API отвсякъде, store / live migration / overlay / Ceph само от членовете, слушателите на мрежовите услуги от обслужваната мрежа. Всяка смяна е apply с потвърждение — възел, който не успее да потвърди, се връща назад сам.'
      },
      confirmTitle: 'Да се наложи ли защитната стена на възлите?',
      confirmBody: 'Всеки възел прилага ruleset-а с потвърждение: сондира бекенда, store и ssh през новите правила в рамките на срока и потвърждава — иначе сам се връща към предишния ruleset. Първо прочетете броячите на разрешителната позиция на възлите.',
      confirmSubmit: 'Наложи',
      confirmCancel: 'Отказ',
      lensTitle: 'Защитна стена на възела',
      loadError: 'Неуспешно зареждане на лупата на защитната стена на възела',
      noReport: 'Все още няма доклад за защитната стена от този възел — уъркърът докладва при следващия си ход',
      firewalldActive: 'На този възел работи firewalld: защитната стена на възела отказва да се приложи редом с него (маскирайте firewalld)',
      conditionUnconfirmed: 'Все още няма потвърден ruleset — възелът е отворен',
      conditionRolledBack: 'Последният apply се върна назад — същото поколение не се опитва отново, докато регистърът не се промени или позицията не бъде сменена отново',
      lastError: 'Последна грешка',
      posture: 'Позиция',
      observedAt: 'Наблюдавано',
      desiredGeneration: 'Желано поколение',
      componentTitle: 'Компонент на възела',
      componentSubtitle: 'tvirt-node-firewall — прилага при зареждане потвърдения ruleset, връща назад сам непотвърден такъв',
      componentAbsent: 'Компонентът още не е докладвал',
      phase: 'Фаза',
      phases: {
        none: 'Никога не е прилаган',
        applied: 'Приложен — чака потвърждение',
        confirmed: 'Потвърден',
        rolledBack: 'Върнат назад'
      },
      generation: 'Поколение',
      appliedAt: 'Приложен на',
      confirmedAt: 'Потвърден на',
      deadline: 'Краен срок на rollback',
      lastRollback: 'Последен rollback',
      registryTitle: 'Производен регистър',
      registrySubtitle: 'Портовете, които този възел отваря, по клас и произход — производни от клъстера, никога редактирани на ръка',
      registryEmpty: 'Нищо производно — изключена позиция без потвърден ruleset, или все още няма доклад',
      colClass: 'Клас',
      colPort: 'Порт',
      colSource: 'Източник',
      colOrigin: 'Произход',
      classes: {
        public: 'Публичен',
        internode: 'Междувъзлов',
        tenant: 'Тенант'
      },
      sourceMembers: 'само членовете',
      sourceAnywhere: 'отвсякъде',
      sourceBridge: 'на {iface}'
    },
    derivationDerived: 'производен',
    derivationDiverged: 'отклонен',
    derivationDerivedTip: 'Мрежовият документ е ПРОИЗВОДЕН от fabric {fabric} и все още съвпада с рендера на текущите входове — клик за плана на деривация.',
    derivationDivergedTip: 'Деривацията от fabric {fabric} се промени след последния apply (fabric, окабеляване, роли или референции) — клик за чакащия diff.',
    derivationRetiring: {
      one: '{n} адрес се източва',
      other: '{n} адреса се източват'
    },
    standaloneHint: 'Този възел няма клъстер: още не е инсталиран. Клъстерите се създават ИЛИ се присъединяват при инсталацията — токенът, генериран от таблицата Сървъри на един член, се подава на инсталатора (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Вашите права покриват един скоуп, не целия клъстер: инвентарът на флота — възли, настройки и устройства — е видим само за администраторите на клъстера.',
    phaseReady: 'Готов',
    phaseForming: 'Във формиране',
    storeMembers: 'Членове на хранилището',
    watermark: 'Праг на конвергенция',
    configGeneration: 'Поколение на конфигурацията',
    converged: 'изравнен',
    behind: 'изостава — {m} / {n}',
    revision: 'Ревизия',
    rolesTitle: 'Мрежови роли',
    rolesSubtitle: 'Адреси по член за всеки клас трафик — свързаността живее в мрежата на хоста',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'наследява management',
    settingsTitle: 'Настройки',
    settingsSubtitle: 'Политика за сигурност на ниво клъстер — оценявана от всеки възел по собствената му локална реплика',
    taskRetentionTitle: 'Задържане на задачите',
    taskRetentionSubtitle: 'Единен GC за всички задачи — завършените задачи над възрастта или тавана се събират, никога текущите',
    taskRetentionMaxAge: 'Максимална възраст (дни)',
    taskRetentionMaxCount: 'Максимален брой задачи',
    eventRetentionTitle: 'Задържане на събития',
    eventRetentionSubtitle: 'GC на дневника — политика, независима от тази на задачите: задачата е опашка, събитието е памет',
    eventRetentionMaxAge: 'Максимална възраст (дни)',
    eventRetentionMaxCount: 'Максимален брой събития',
    spaceThresholdsTitle: 'Прагове на пространството',
    spaceThresholdsSubtitle: 'Кога пълнещо се хранилище попада в дневника (и в известията)',
    spaceLowPct: 'Предупреждение от (% използвано)',
    spaceCriticalPct: 'Критично от (% използвано)',
    spaceOrderError: 'Критичното не може да е под предупреждението',
    spaceThresholdsHint: 'Конфигурират се само входовете: изходът се извежда от двигателя, 5 пункта под всеки праг, за да не се превърне хранилище на линията в метроном',
    failoverReserveTitle: 'Резерв за аварийно превключване',
    failoverReserveSubtitle: 'Admission control N+1 — RAM, пазена свободна, за да може клъстерът да рестартира товара си след загуба на възли',
    failoverReserveTolerate: 'Възли, чиято загуба да се издържи',
    failoverReserveOff: '0 — резервът е изключен: никой старт никога не се отказва заради капацитет за аварийно превключване',
    failoverReserveOn: 'Старт, който би засегнал резерва, се отказва с 412, който обяснява числата',
    networkShapingTitle: 'Справедливост на честотната лента',
    networkShapingSubtitle: 'Трите тегла по типология на дървото за shaping на всеки uplink — действат само при конкуренция',
    networkShapingRest: 'Тегло на останалото (контролен слой, storage, реплики)',
    networkShapingOverlay: 'Тегло на overlay мрежите',
    networkShapingLiveMigration: 'Тегло на live migration',
    networkShapingHint: 'Гарантиран дял = тегло / сбор на трите (по подразбиране 300 / 100 / 200, всяко от 1 до 10000); при свободна връзка всеки клас може да заеме цялата лента',
    debugModeTitle: 'Debug режим',
    debugModeSubtitle:
      'Подробни грешки в общите съобщения на GUI — за да видите истинската причина, когато действие, обявено за „неуспешно“, всъщност е успяло',
    debugModeLabel: 'Debug режим включен',
    debugModeOn: 'Общите съобщения за грешка добавят основната причина — вътрешни подробности, видими за всеки оператор',
    debugModeOffHint: 'Изключен — общите съобщения за грешка остават общи, без вътрешни подробности',
    nodeDetailsAction: 'Детайли за възела',
    node: {
      docTitle: 'Възел',
      notFound: 'Възелът не е намерен',
      tabOverview: 'Преглед',
      tabStats: 'Статистики',
      tabNetwork: 'Мрежа',
      tabSettings: 'Локални настройки',
      identityTitle: 'Идентичност',
      heartbeatTitle: 'Пулс',
      ysqlPort: 'YSQL порт',
      revision: 'Ревизия на конфигурацията',
      versionsTitle: 'Наблюдавани версии',
      heartbeatSubtitle: 'Последното състояние, което възелът е докладвал за себе си',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Модел CPU',
      memoryTitle: 'Памет',
      hugePagesTitle: 'Огромни страници',
      hugePagesPool: '{size}: {free} свободни от {total}',
      hugePagesNone: 'Няма пул',
      hugePagesNoneHint: 'Възелът няма запазени огромни страници: ВМ, които искат такива, не могат да стартират тук. Пулът се декларира на възела — с параметрите hugepagesz и hugepages на ядрото или чрез запис в nr_hugepages.',
      usageTitle: 'Текуща употреба',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'не е наблюдавано — няма свеж отчет',
      statsNoData: 'Няма данни в интервала — сериите на възела се отчитат от самия възел и се сервират локално.',
      observedTitle: 'Наблюдавано състояние',
      observedSubtitle: 'Услуги и активи, локални за възела, както ги вижда уъркърът'
    },
    editRolesTitle: 'Редактиране на мрежовите роли',
    memberNode: 'Възел',
    memberIp: 'IP адрес',
    addMember: 'Добави член',
    lmInherit: 'Използвай адресите за management',
    roleIpHint: 'Добавянето и премахването на членове е свободно; промяната на място на IP на съществуващ член се отказва — потокът за IP миграция идва в следващ рунд.',
    roleError: 'Неуспешно обновяване на ролите',
    nodesTitle: 'Възли',
    addNodeTitle: 'Добавяне на възел към клъстера',
    addNode: 'Добави възел',
    addNodeError: 'Неуспешна предварителна регистрация на възела',
    nodeName: 'Име на възела',
    nodeNameHint: 'трябва да съвпада с името, избрано при инсталацията',
    nodeIp: 'Management IP',
    colName: 'Име',
    colPhase: 'Фаза',
    colServices: 'Услуги',
    colWatermark: 'Watermark',
    colLastSeen: 'Последен контакт',
    colUps: 'UPS',
    upsCordonChip: 'UPS кордон',
    upsCordonTip: 'Възелът се осъди по фактите на своя UPS ({time}): сам ще вдигне кордона, когато мрежата е стабилна и батерията е заредена',
    upsUnreachable: 'UPS недостъпен',
    upsOnBattery: 'На батерия',
    upsOnLine: 'На мрежа',
    upsLowBattery: 'слаба батерия',
    upsNoEstimateChip: 'автономността не е оценена',
    upsNoEstimateTip: 'UPS не публикува оценка на автономността: възелът се осъжда само от флага LB (слаба батерия) на UPS — настройте battery.runtime.low / LB на самия UPS',
    upsLaneTip: 'Път на изключване по UPS от {since}: осъден от {by}',
    upsUnit: 'устройство',
    upsStatus: 'състояние NUT',
    upsLoad: 'натоварване',
    upsOnBatterySince: 'на батерия от',
    upsOnLineSince: 'на мрежа от',
    upsError: 'грешка',
    upsObservedAt: 'наблюдавано',
    upsNone: 'никое UPS устройство не обслужва този възел',
    upsBy: {
      runtime: 'автономност под прага',
      lowBattery: 'флаг LB на UPS',
    },
    upsLane: {
      evacuate: 'евакуация',
      local: 'изключване на място',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'спиране на гостите',
      stoppingServices: 'спиране на услугите',
      poweredOff: 'изключен',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS устройства и прагове: възелът се осъжда при автономност ≤ праг или флаг LB (винаги зачитан), възобновяване с хистерезис',
    upsRuntimeThreshold: 'Праг на автономност (s)',
    upsRuntimeThresholdHint: 'На батерия с оценена автономност ≤ праг възелът се изключва подред (по подразбиране 300)',
    upsResumeStable: 'Мрежа стабилна в продължение на (s)',
    upsResumeStableHint: 'Възобновяване само при непрекъсната мрежа поне толкова секунди (по подразбиране 60)',
    upsResumeCharge: 'Минимален заряд при възобновяване (%)',
    upsResumeChargeHint: 'И батерия заредена поне до този процент (по подразбиране 25)',
    upsPolicyNote: 'Флагът LB (слаба батерия) на UPS винаги осъжда и не може да се изключи; няма праг за времето на батерия. Всяко устройство може да презапише трите числа.',
    upsUnitNew: 'ново устройство',
    upsUnitSelectors: '{n} селектор(а) по тагове (само CLI)',
    upsUnitName: 'Име на устройството',
    upsUnitMode: 'Режим',
    upsModeExternal: 'външно (чужд upsd)',
    upsModeManaged: 'управлявано (UPS свързан към възел)',
    upsUnitUpsname: 'NUT име (upsname)',
    upsUnitHost: 'upsd хост',
    upsUnitAttachedNode: 'Свързан възел',
    upsUnitDriver: 'NUT драйвер',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Устройство на драйвера',
    upsUnitDeviceHint: 'редът port= в ups.conf: празно = auto',
    upsUnitPort: 'upsd порт',
    upsUnitServedNodes: 'Обслужвани възли',
    upsUnitServedNodesHint: 'имена на възли, разделени със запетаи (селекторите по тагове минават през CLI)',
    upsUnitOverrideHint: 'празно = по подразбиране на клъстера',
    upsUnitAdd: 'Добави устройство',
    unreachableSince: 'Недостъпен — последен пулс {time}',
    overlaysChip: 'оверлей',
    overlaysBehind: 'Оверлейният дейтаплейн още не е реализирал текущата оверлейна конфигурация',
    overlaysError: 'Последният ход на оверлейно съгласуване се провали: {error}',
    storeChip: 'хранилище',
    phase: {
      'pending-join': 'Чака присъединяване',
      'joining': 'Присъединява се',
      'member': 'Член'
    },
    tokenTitle: 'Токен за присъединяване',
    tokenOnce: 'Показва се само сега — копирайте го веднага, няма да може да се прочете отново',
    copy: 'Копирай',
    copied: 'Копирано',
    close: 'Затвори',
    revokeTitle: 'Отзоваване на предварителната регистрация',
    revoke: 'Отзови',
    revokeError: 'Неуспешно отзоваване на регистрацията',
    promote: 'Повиши до член на хранилището',
    demote: 'Премахни ролята член на хранилището',
    troubleshoot: 'Отстраняване на проблеми',
    promoteTitle: 'Повишаване до член на хранилището',
    demoteTitle: 'Премахване на ролята член на хранилището',
    promoteHint: 'Възелът влиза в кворума на YugabyteDB мастерите. Истинската HA изисква три члена на хранилището.',
    demoteHint: 'Възелът излиза от кворума на мастерите и спира услугите си за хранилището.',
    storeError: 'Промяната на член на хранилището беше отказана',
    attest: 'Атестирай като изключен…',
    attestTitle: 'Атестиране на възела като изключен',
    attestSubmit: 'Атестирай като изключен',
    attestConfirm: 'Декларирате този възел за изключен на свой риск: атестирането на всъщност жив възел рискува ВМ в двойно изпълнение. Задачите му се провалят, а отговорностите за неговите ВМ стават прехвърляеми.',
    attestError: 'Атестацията беше отказана',
    attestedChip: 'атестиран като изключен',
    maintenanceChip: 'поддръжка',
    guestToolsChip: 'TVirt Guest Tools (ISO актив, локален за възела)',
    maintenanceEnter: 'Влез в поддръжка',
    maintenanceExit: 'Излез от поддръжка',
    maintenanceEnterTitle: 'Влизане в поддръжка',
    maintenanceExitTitle: 'Излизане от поддръжка',
    maintenanceEnterSubmit: 'Влез в поддръжка',
    maintenanceExitSubmit: 'Излез от поддръжка',
    maintenanceEnterConfirm: 'Възелът се поставя в кордон и се изпразва: мрежовите услуги и App инстанциите, чийто authority държи, се прехвърлят (инстанциите на студено: спрени и пожънати тук, пресъздадени на целевия възел — престой), работещите VM се мигрират на живо където е възможно и се спират плавно иначе, текущите задачи приключват, новата работа се задържа, а спрените VM губят своя authority — Proximity ги разполага отново при следващото стартиране. Нищо не се връща само в края на поддръжката.',
    maintenanceExitConfirm: 'Възелът отново поема работа и Proximity пак го взима предвид за разполагането. ВМ се връщат само когато бъдат стартирани.',
    maintenanceError: 'Заявката за поддръжка беше отказана',
    maintenancePlanTitle: 'План за евакуация',
    maintenancePlanLoading: 'Изчисляване на плана за евакуация…',
    maintenancePlanError: 'Неуспешно зареждане на плана за евакуация — изпразването все пак ще мигрира, където е възможно, и ще спре останалото.',
    maintenancePlanEmpty: 'Няма какво да се евакуира от този възел — няма активна мрежова услуга, няма App инстанция, поискана в изпълнение, няма работеща VM.',
    maintenancePlanSummary: '{migrate} обекта ще мигрират (VM, мрежови услуги, App инстанции), {stop} ще спрат или ще останат където са.',
    maintenancePlanReserve_ok: 'Резерв за аварийно превключване след изпразването: непокътнат — остават {headroom} GiB стартируеми при издържане на загубата на {n} възел(а).',
    maintenancePlanReserve_eroded: 'Резерв за аварийно превключване след изпразването: почти изчерпан — остават само {headroom} GiB от {reserve} GiB, пазени свободни за {n} отказ(а) на възел.',
    maintenancePlanReserve_exhausted: 'Резерв за аварийно превключване след изпразването: ИЗЧЕРПАН — липсват {headroom} GiB от {reserve} GiB, нужни за издържане на {n} отказ(а) на възел. Докато този възел е извън строя, новите стартове на ВМ ще бъдат отказвани.',
    maintenancePlanReserve_unknown: 'Резерв за аварийно превключване след изпразването: не може да се изчисли — никой останал възел не е декларирал паметта си.',
    maintenancePlanReserveHugePages: 'Огромни страници по {size} след изпразването — свободни: {free} от {capacity}, изисквани като резерв: {reserve}.',
    maintenancePlanActionMigrate: 'мигрира',
    maintenancePlanActionMigrateWarning: 'мигрира (нарушено меко правило)',
    maintenancePlanActionStop: 'спира',
    maintenancePlanActionBlocked: 'блокирана',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'мрежова услуга',
    maintenancePlanKindApp: 'App инстанция',
    maintenancePlanColdMove: 'Преместване на студено: подът се спира и пожънва тук и се пресъздава на целевия възел от неговия worker — престой до следващия pass на целевия worker.',
    caFingerprint: 'Отпечатък на CA на клъстера',
    staleChip: 'не е актуален',
    troubleshootTitle: 'Отстраняване на проблеми с хранилището',
    restartStore: 'Рестартирай услугите на хранилището',
    restartHint: 'Ако хранилището капризничи, рестартирайте услугите му. За напреднали — използвайте с внимание.',
    restartQueued: 'Задачата за рестарт е в опашка',
    restartError: 'Неуспешен рестарт на услугите',
    svcActive: 'активна',
    svcWanted: 'желана, неактивна',
    svcStopped: 'спряна',
    noServices: 'Няма докладвани услуги'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'GPU инвентарът на целия клъстер, групиран по модел — наблюдаваните карти по възел, с маркираните регистрации и техните тагове',
    usbTitle: 'USB ресурси',
    usbSubtitle: 'USB инвентарът на целия клъстер, групиран по модел — наблюдаваните устройства по възел, с регистрациите по двата модела (по устройство, по порт) и техните тагове',
    markedChip: '{n} използваеми от TVirt',
    orphanChipGpu: '{n} осиротели',
    orphanChipUsb: '{n} осиротели',
    colNode: 'Възел',
    colRegistration: 'Регистрация',
    noRegsHint: 'Няма регистрации — устройството се маркира „използваемо от TVirt“ от диалога на възела (Възли › възел › Настройки).',
    colDevice: 'Устройство',
    colObserved: 'Наблюдавани',
    colRegs: 'Регистрации',
    regsNone: 'няма',
    colPci: 'PCIe адрес',
    colIdentity: 'Идентичност / порт',
    colClasses: 'Класове (тагове)',
    colActions: 'Действия',
    manageOnNode: 'Управлявай на възел {node} (маркирането живее в диалога на възела)',
    introTitle: 'Клъстерният инвентар на USB и PCIe устройствата, използваеми от TVirt©.',
    introStep1: '1. Възлите сами откриват своите GPU и USB устройства (преброяване в пулса).',
    introStep2: '2. Устройство се маркира „използваемо от TVirt“ от диалога на ВЪЗЕЛА (Възли › възел › Настройки) — маркирането го връзва към vfio и го регистрира тук.',
    introStep3: '3. Тук давате на регистрациите техните КЛАСОВЕ чрез тагове (напр. gpu_class=compute): изискванията на ВМ ще искат клас, а планировчикът ще избере възел със свободно съвместимо устройство.',
    colMode: 'Режим',
    colState: 'Състояние',
    colNotes: 'Бележки',
    colTags: 'Тагове',
    modeDevice: 'по устройство',
    modePort: 'по порт',
    usable: 'използваемо',
    orphanGpu: 'осиротяла',
    orphanUsb: 'осиротяло',
    hubChip: 'хъб',
    orphanPortsTitle: 'Регистрации по порт без свързано устройство — свържете отново устройство или ги размаркирайте от възела',
    gpusEmpty: 'Още няма наблюдавана GPU на нито един възел',
    usbEmpty: 'Още няма наблюдавано USB устройство на нито един възел'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Минимална дължина на паролата',
    sessionIdle: 'Таймаут при неактивност на сесията (минути)',
    lockoutThreshold: 'Блокиране след неуспешни опити',
    lockoutDuration: 'Продължителност на блокирането (минути)',
    keyboardLayout: 'Клавиатурна подредба',
    keyboardLayoutHint: 'напр. it, en-us — празно за подразбирането на QEMU',
    syslogEndpoint: 'Syslog крайна точка',
    syslogEndpointHint: 'хост:порт — празно, за да се изключи препращането',
    syslogTls: 'TLS',
    maxQueued: 'Максимум задачи в опашка',
    concurrency: 'Конкурентност на уъркъра',
    concurrencyHint: 'Прилага се в движение от уъркъра',
    notesTitle: 'Бележки',
    save: 'Запази',
    saved: 'Настройките са запазени',
    saveError: 'Неуспешно запазване на настройките'
  },
  localSettings: {
    derivedChip: 'производен',
    derivedTip: 'Този device е СОБСТВЕНОСТ на деривацията на fabric (H2): редакторът отказва да го докосне — променете fabric (или окабеляването) и приложете отново, или си го вземете обратно по-долу.',
    takeOwnership: 'Поеми собственост',
    takeOwnershipTitle: 'Поеми собственост (take-ownership)',
    takeOwnershipConfirm: '{name} напуска блока fabric и отново става РЪЧЕН device, управляван от този редактор. Възелът става отклонен и следващият apply на деривацията ще откаже на него (manualConflict), докато не го преименувате или премахнете — или не поправите fabric.',
    nodeSettingsTitle: 'Настройки на възела',
    nodeSettingsSubtitle: 'Това, което този възел прилага — опашка на задачите, конзола, препращане на логовете — плюс неговите тагове и бележки',
    baseTitle: 'Резерви на хоста (TVirt Proximity)',
    baseSubtitle: 'CPU и RAM, запазени за операционната система на хоста — входовете на емпиричния капацитет, с който Proximity разполага ВМ',
    baseMemory: 'Базова RAM (MiB)',
    baseMemoryHint: 'Наблюдаван общ обем: {total} MiB. Използваема за ВМ = общо − база − RAM на включените ВМ, разположени тук.',
    baseMemoryHintNoTotal: 'Използваема за ВМ = наблюдавано общо − база − RAM на включените ВМ, разположени тук.',
    baseCpu: 'Базови CPU ядра',
    baseCpuHint: 'Наблюдавани логически CPU: {total}. Използват се само като тежест при класирането — овъркомитът на vCPU е нормален.',
    baseCpuHintNoTotal: 'Използват се само като тежест при класирането — овъркомитът на vCPU е нормален.',
    baseHint: 'RAM е твърдата бариера за допускане: ВМ, която не се побира в използваемата RAM, се отказва с ясна грешка. Вдигнете базата на хостовете, които носят членове на хранилището или Ceph демони.',
    placementTitle: 'Физическо разположение',
    placementSubtitle: 'Къде стои физически този сървър — декларирано веднъж, за каквото потрябва',
    placementHint: 'Разположението води CRUSH йерархията на всеки Ceph клъстер с OSD на този сървър: запазването на промяна изравнява картите им чрез задача (host → rack → … → root). Частичните декларации са легални — празните нива се свиват. Имената са споделени по цялата карта: два сървъра в един и същи rack декларират едно и също име на rack.',
    placementNameInvalid: 'DNS-безопасно име (малки букви, цифри, тирета)',
    placementEmpty: 'Празно = недекларирано',
    placementLevel: {
      chassis: 'Шаси',
      rack: 'Rack',
      row: 'Редица',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Помещение',
      datacenter: 'Датацентър',
      zone: 'Зона',
      region: 'Регион'
    },
    cablingTitle: 'Окабеляване',
    cablingSubtitle: 'Към кой порт на комутатора е свързан всеки интерфейс — декларацията живее на възела (Annex O.9)',
    cablingHint: 'Един кабел на NIC, един кабел на порт в целия флот (API-то отказва, назовавайки титуляря). Окабеляване към порт, член на LAGG, е легално — това е случаят бонд: бъдещото извеждане ще го предаде като LACP.',
    cablingInterface: 'Интерфейс',
    cablingNotCabled: '— не е свързан —',
    cablingNoInterfaces: 'Няма наблюдавани мрежови интерфейси',
    disksTitle: 'Дискове',
    disksSubtitle: 'Наблюдавани блокови устройства — по едно сканиране на ход на съгласуване; отбележете тук дисковете, използваеми като Ceph OSD (N.15: пригодността е явна)',
    colDataDisk: 'Диск за данни',
    dataDisksHint: 'Отмятането на устройство го декларира използваемо като OSD; серийният номер е неговият идентификационен щифт — копиран от хардуера, когато дискът го докладва, изкован (tvirt-…) иначе. Диалогът за Ceph регистрация предлага само декларираните дискове.',
    diskDeclaredSerial: 'деклариран',
    diskNotObserved: 'деклариран, но не наблюдаван — закачете отново устройството или махнете отметката',
    noDisks: 'Още няма наблюдавани блокови устройства',
    colSerial: 'Сериен номер',
    colModel: 'Модел',
    colSize: 'Размер (GiB)',
    colDiskType: 'Тип',
    colInUse: 'В употреба',
    colObservedAt: 'Наблюдаван',
    diskInUse: 'в употреба',
    diskFree: 'свободен',
    diskMounted: 'монтиран',
    diskPartitions: 'дялове',
    passthroughTitle: 'Passthrough устройства',
    passthroughSubtitle: 'Наблюдавани GPU и USB устройства — отбележете тук какво TVirt може да подава на ВМ; маркирането регистрира идентичността на устройството (рунд U1+G1)',
    passthroughHint: 'Маркирането регистрира устройството (стабилно id — целта на тагове и класови изисквания). Маркирана GPU има ЦЯЛАТА си IOMMU група вързана към vfio-pci наведнъж — напуска хоста веднага; размаркирането закача отново родния драйвер. За USB съществуват и двата ратифицирани модела: по устройство (vendor+product, където и да е закачено) и по физически порт (до ВМ стига каквото е втъкнато в него). USB не прави bind при маркирането — закачането става по време на работа на ВМ.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Използваемо от TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI адрес',
    colDriver: 'Драйвер',
    colVerdict: 'Заключение',
    gpuEligible: 'Пригодна',
    gpuIneligible: 'Непригодна',
    gpuReason: {
      'no-iommu': 'IOMMU не е активен на хоста',
      'group-spans-slots': 'IOMMU групата не е изолирана: простира се върху други слотове',
      'multiple-display': 'IOMMU групата не е изолирана: повече от една видео функция',
      'foreign-function': 'IOMMU групата не е изолирана: съдържа чужда функция'
    },
    vfioNotReady: 'IOMMU не е активен на този хост: никоя GPU не е пригодна, докато хост платформата не го включи (OEM ISO) — TVirt никога не пипа kernel args по време на работа.',
    vfioMissingKernelArg: 'IOMMU не е активен на този хост: фърмуерът докладва VT-d/AMD-Vi (ACPI таблица DMAR/IVRS налична), но липсва kernel arg — добавете intel_iommu=on (Intel) или махнете amd_iommu=off (AMD) от командния ред на ядрото и рестартирайте. TVirt никога не пипа kernel args по време на работа.',
    vfioFirmwareDisabled: 'IOMMU не е активен на този хост: VT-d/AMD-Vi е изключен във фърмуера (няма ACPI таблица DMAR/IVRS) или CPU не го поддържа — включете го в настройките на фърмуера, никой kernel arg не може да го запали. TVirt никога не пипа хоста по време на работа.',
    gpuBindError: 'Bind към vfio-pci се провали на {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Защитна стена върху неуправлявани бриджове',
    firewallBridgesSubtitle: 'Ръчно построените бриджове на този възел, чиято настройка се съгласява с веригите на защитната стена, рендирани от TVirt върху закачените NIC на гостите',
    firewallBridgesHint: 'TVirt никога не докосва чуждия бридж — веригата се закотвя върху tap/veth, който винаги е на TVirt. Списъкът е порта на съгласието: default-deny и anti-spoof могат да счупят това, което една ръчна настройка очаква, затова NIC със защитна стена върху неуправляван бридж, който НЕ е изброен тук, се отказва с говореща грешка.',
    firewallBridgesEmpty: 'Никой неуправляван бридж не се съгласява с веригите на защитната стена, рендирани от TVirt на този възел.',
    firewallBridgeAdd: 'Добави бридж',
    firewallBridgeInvalid: 'Не е име на Linux интерфейс (1-15 знака, без наклонена черта и интервали)',
    firewallBridgeDuplicate: 'Името вече е в списъка',
    colMarkDevice: 'По устройство',
    colMarkPort: 'По порт',
    usbHub: 'хъб',
    colUsbId: 'Vendor:Product',
    colPort: 'Порт',
    passthroughOrphan: 'осиротяло — регистрирано, но вече не се засича: свържете го отново или го размаркирайте',
    noGpus: 'Още няма наблюдавана GPU',
    noUsb: 'Още няма наблюдавано USB устройство',
    networkGeneration: 'Мрежово поколение',
    applied: 'Приложено',
    converged: 'изравнен',
    behind: 'изостава — {m} / {n}',
    notConfigured: 'не е конфигурирано',
    rollbackBody: 'Прилагането на поколение {gen} се провали: {error}',
    rolledBackChip: 'върнато назад',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Регистърът на управляваните NIC — регистрацията Е декларацията за управление: регистрирана NIC без конфигурация не се пипа (clear-if я декларира изрично чиста), нерегистрирано устройство никога не се пипа',
    addNic: 'Регистрирай NIC',
    addNicTitle: 'Регистриране на NIC (add-nic)',
    delNic: 'Прекрати управлението',
    delNicTitle: 'Прекратяване на управлението (del-nic)',
    delNicConfirm:
      'Управлението на {name} се прекратява: записът в регистъра и конфигурацията му се изтриват, а TVirt профилът се премахва — устройството остава, както Linux го е оставил.',
    nicName: 'Име на устройството',
    nicMac: 'Постоянен MAC адрес',
    nicMacHint: 'постоянният хардуерен MAC — стабилната идентичност, фиксирана от TVirt Server Installer',
    colObserved: 'Наблюдавана',
    nicObserved: 'наблюдавана',
    nicNotObserved: 'не е наблюдавана',
    nicMacMismatch: 'Разминаващ се MAC — наблюдаван {mac}',
    noNics: 'Няма регистрирани NIC — регистрирайте устройство, за да започнете да го управлявате',
    noManagedDevices: 'Няма управлявани устройства — първо регистрирайте NIC, всичко се гради върху регистъра',
    inventoryTitle: 'Наблюдавани устройства',
    inventorySubtitle: 'Обновяват се при всеки ход на съгласуване от уъркъра на възела — валидацията проверява имената на устройствата по този инвентар',
    colDevice: 'Устройство',
    colType: 'Тип',
    colMac: 'MAC',
    colLink: 'Линк',
    colSpeed: 'Скорост',
    colTopology: 'Топология',
    colMtu: 'MTU',
    colAddresses: 'Адреси',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP не агрегира',
    noInventory: 'Досега няма докладвани устройства',
    interfacesTitle: 'Интерфейси',
    interfacesSubtitle:
      'L3 конфигурация на регистрираните NIC и декларираните логически устройства — set-if заменя целия блок, edit-if ретушира свойствата, clear-if го изпразва (явно почистване)',
    colConfig: 'Желана конфигурация',
    clean: 'чиста',
    setIf: 'Промени адресирането',
    setIfTitle: 'Промяна на адресирането (set-if)',
    editIf: 'Промени свойствата',
    editIfTitle: 'Промяна на свойствата (edit-if)',
    clearIf: 'Изпразни конфигурацията',
    clearIfTitle: 'Изпразване на конфигурацията (clear-if)',
    clearIfConfirm: 'Конфигурацията на интерфейса се изпразва. Чистият интерфейс е предпоставката, за да го подчините като член на бонд/бридж или родител на VLAN.',
    ip4Mode: 'IPv4 режим',
    ip6Mode: 'IPv6 режим',
    modeUnconfigured: 'Неконфигуриран',
    modeStatic: 'Статичен',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4 адреси',
    ip6Addresses: 'IPv6 адреси',
    addressesHint: 'CIDR, разделени със запетая',
    gw4: 'IPv4 шлюз',
    gw6: 'IPv6 шлюз',
    dns: 'DNS сървъри',
    dnsHint: 'разделени със запетая — празно нулира DNS (set-if заменя блока)',
    routes4: 'Статични IPv4 маршрути',
    routes6: 'Статични IPv6 маршрути',
    routeTo: 'Дестинация (CIDR)',
    routeVia: 'През',
    addRoute: 'Добави маршрут',
    routesChip: 'маршрути',
    mtu: 'MTU',
    mtuHint: 'празно = подразбирането на драйвера',
    vlansTitle: 'VLAN',
    addVlan: 'Добави VLAN',
    addVlanTitle: 'Добавяне на VLAN (add-vlan)',
    delVlanTitle: 'Изтриване на VLAN (del-vlan)',
    vlanParent: 'Родителски интерфейс',
    vlanId: 'VLAN ID',
    vlanPreview: 'Име на устройството',
    colParent: 'Родител',
    colVlanId: 'ID',
    noVlans: 'Няма декларирани VLAN',
    bondsTitle: 'Бондове',
    addBond: 'Добави бонд',
    addBondTitle: 'Добавяне на бонд (add-bond)',
    editBondTitle: 'Редактиране на бонда',
    editBond: 'Запази бонда',
    delBondTitle: 'Изтриване на бонда (del-bond)',
    bondName: 'Име на бонда',
    members: 'Членове',
    membersHint: 'членовете трябва да са чисти интерфейси (без L3 конфигурация)',
    bondMode: 'Режим',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Първичен член',
    rate: 'LACP rate',
    hash: 'Политика на хеширане при предаване',
    colMembers: 'Членове',
    colMode: 'Режим',
    noBonds: 'Няма декларирани бондове',
    bridgesTitle: 'Бриджове',
    addBridge: 'Добави бридж',
    addBridgeTitle: 'Добавяне на бридж (add-bridge)',
    editBridgeTitle: 'Редактиране на бриджа',
    editBridge: 'Запази бриджа',
    delBridgeTitle: 'Изтриване на бриджа (del-bridge)',
    bridgeName: 'Име на бриджа',
    stp: 'STP',
    stpOn: 'STP включен',
    stpOff: 'STP изключен',
    colStp: 'STP',
    noBridges: 'Няма декларирани бриджове',
    hostnameTitle: 'Име на хоста',
    hostname: 'Име на хоста',
    setHostname: 'Задай име на хоста',
    setHostnameTitle: 'Задаване на име на хоста (set-hostname)',
    hostnameHint: 'Само идентичност на ОС — името на възела в клъстера не се пипа',
    notSet: 'не е зададено',
    staticHostsTitle: 'Статични записи за хостове',
    addStaticHost: 'Добави запис',
    addStaticHostTitle: 'Добавяне на статичен запис за хост',
    delStaticHostTitle: 'Изтриване на статичния запис за хост',
    hostIp: 'IP адрес',
    hostNames: 'Имена',
    hostNamesHint: 'разделени със запетая или интервал',
    colIp: 'IP',
    colNames: 'Имена',
    noStaticHosts: 'Няма статични записи за хостове',
    delConfirm: 'Премахване на {name} от желания документ — уъркърът на възела се схожда с контролна точка на NetworkManager и автоматично връщане назад.',
    remove: 'Премахни',
    opError: 'Мрежовата операция беше отказана'
  }
}
